export default __webpack_public_path__ + "static/media/parallax-bg33.e88e3217.jpg";